function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.50449 20.071c0-10.775 8.7478-19.523 19.523-19.523 10.813 0 19.523 8.7478 19.523 19.523 0 10.813-8.7102 19.523-19.523 19.523-10.775 0-19.523-8.7102-19.523-19.523z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.50449 20.071c0-10.775 8.7478-19.523 19.523-19.523 10.813 0 19.523 8.7478 19.523 19.523 0 10.813-8.7102 19.523-19.523 19.523-10.775 0-19.523-8.7102-19.523-19.523",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m10.566 14.927c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-1.5018-3.4165-3.379z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m10.638 15.019c0-1.9241 1.5385-3.5019 3.4147-3.5019h16.023c1.8762 0 3.3772 1.5778 3.3772 3.5019v13.969c0 1.9241-1.501 3.4634-3.3772 3.4634h-16.023c-1.8762 0-3.4147-1.5393-3.4147-3.4634z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.0122
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m13.983 11.511h15.994c1.9147 0 3.4165 1.5393 3.4165 3.379v3.8295h-22.827v-3.8295c0-1.8397 1.5393-3.379 3.4165-3.379z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m14.048 11.38h15.994c1.9147 0 3.4165 1.5393 3.4165 3.379v3.8295h-22.827v-3.8295c0-1.8397 1.5393-3.379 3.4165-3.379z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref8 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m6.6617 11.623c0-1.8772 1.5393-3.4165 3.4165-3.4165h16.031c1.8772 0 3.379 1.5393 3.379 3.4165v13.628c0 1.8772-1.5018 3.379-3.379 3.379h-16.031c-1.8772 0-3.4165-1.5018-3.4165-3.379z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m10.078 8.2068h15.994c1.9147 0 3.4165 1.5393 3.4165 3.4541v3.9046h-22.827v-3.9046c0-1.9147 1.5393-3.4541 3.4165-3.4541z",
  fill: "#ecaec6"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m10.867 11.173c0-0.22526 0.18272-0.41298 0.40198-0.41298h13.558c0.21926 0 0.36544 0.18772 0.36544 0.41298v1.6144c0 0.22526-0.14618 0.37544-0.36544 0.37544h-13.558c-0.21926 0-0.40198-0.15018-0.40198-0.37544z",
  fill: "#adb9ca"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m22.43 17.48c0.37544 0 0.78842 0.15018 1.0888 0.45053 0.6007 0.6007 0.6007 1.5768 0 2.1776l-5.8944 5.932c-0.30035 0.30035-0.67579 0.45053-1.0888 0.45053-0.41298 0.03754-0.78842-0.11263-1.0888-0.45053l-2.7032-2.6656c-0.6007-0.6007-0.6007-1.5768 0-2.1776 0.6007-0.6007 1.5768-0.6007 2.1776 0l1.6144 1.5768 4.8056-4.8432c0.30035-0.30035 0.67579-0.45053 1.0888-0.45053z",
  fill: "#adb9ca"
}));
var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "m6.4639 11.894c0-1.8475 1.5528-3.3625 3.4464-3.3625h16.172c1.8936 0 3.4085 1.515 3.4085 3.3625v13.413c0 1.8475-1.5149 3.3255-3.4085 3.3255h-16.172c-1.8936 0-3.4464-1.478-3.4464-3.3255z",
  strokeWidth: 0.99639
}), React.createElement("path", {
  d: "m9.9044 8.5234h16.145c1.9329 0 3.4489 1.4638 3.4489 3.2845v3.7129h-23.043v-3.7129c0-1.8208 1.5539-3.2845 3.4489-3.2845z",
  strokeWidth: 0.97976
}), React.createElement("path", {
  d: "m10.442 11.093c0-0.27723 0.19358-0.50826 0.42588-0.50826h14.364c0.2323 0 0.38717 0.23103 0.38717 0.50826v1.9868c0 0.27723-0.15487 0.46205-0.38717 0.46205h-14.364c-0.2323 0-0.42588-0.18482-0.42588-0.46205z",
  strokeWidth: 1.0619
}), React.createElement("path", {
  d: "m22.43 17.48c0.37544 0 0.78842 0.15018 1.0888 0.45053 0.6007 0.6007 0.6007 1.5768 0 2.1776l-5.8944 5.932c-0.30035 0.30035-0.67579 0.45053-1.0888 0.45053-0.41298 0.03754-0.78842-0.11263-1.0888-0.45053l-2.7032-2.6656c-0.6007-0.6007-0.6007-1.5768 0-2.1776 0.6007-0.6007 1.5768-0.6007 2.1776 0l1.6144 1.5768 4.8056-4.8432c0.30035-0.30035 0.67579-0.45053 1.0888-0.45053z"
}));
var SvgSurveyModelTabTemplates = function SvgSurveyModelTabTemplates(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabTemplates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Templates.1f8cc650.svg";
export { ForwardRef as ReactComponent };